// extracted by mini-css-extract-plugin
export default {"marginTop":"Error500Page_marginTop__nUnp7","errorBox":"Error500Page_errorBox__VC4eA","link":"Error500Page_link__Z07W7"};